<template>
  <div>
    <div class="sub-title my-3">자가진단 필답 평가</div>
    <div>
      <mdb-row class="underline bolder my-3">
        <mdb-col md="8">교과목/능력단위</mdb-col>
        <mdb-col md="2" class="text-right">평가일</mdb-col>
        <mdb-col md="2" class="text-right"></mdb-col>
      </mdb-row>
      <div v-for="(s, i) in subjects.NCS" :key="i">
        <div class="title my-3"><mdb-icon icon="chalkboard-teacher" /> {{s.name}}</div>
        <mdb-row class="ml-3 my-1 underline" v-for="(l, i) in s.lectures" :key="i">
          <mdb-col md="8">
            <mdb-icon icon="chalkboard" /> {{l.name}}
          </mdb-col>
          <mdb-col md="2" class="text-right">
            {{$strDate(l.test1Date)}}
          </mdb-col>
          <mdb-col md="2" class="text-right">
            <mdb-btn icon="search" color="success" class="p-1 pr-2" v-if="hasAnswer(l.code)" @click="onViewResult(l)"> 결과보기</mdb-btn>
            <mdb-btn icon="edit" class="p-1 pr-2" v-if="!hasAnswer(l.code) && $isTestDate(l.test1Date)" @click="onTest(l)"> 응시하기</mdb-btn>
          </mdb-col>
        </mdb-row>
      </div>
    </div>
    <!-- <div v-if="mode === 'TEST'">
      <student-self-test-exam :lecture="lecture"/>
    </div>
    <div v-if="mode === 'VIEW'">
      <student-self-test-exam />
    </div> -->
  </div>
</template>
<script>
import { } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  components: { },
  name: 'StudentSelfTest',
  props: ['training'],
  data: () => ({
    lecture: {},
    answers: {}
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('subject', ['subjects'])
  },
  methods: {
    async load () {
      if (this.profile.training) {
        const training = this.profile.training._id
        const student = this.profile._id
        this.answers = await this.$getSelfTestAnswerList({ student })
      }
    },
    hasAnswer (code) {
      return this.answers[code]
    },
    onViewResult (l) {
      const query = {
        category: l.category,
        subjectId: l.subject,
        code: l.code
      }
      this.$router.push({ name: 'StudentSelfTestView', query })
    },
    onTest (l) {
      const query = {
        category: l.category,
        subjectId: l.subject,
        code: l.code
      }
      this.$router.push({ name: 'StudentSelfTestExam', query })
    }
  },
  created () { this.load() },
  watch: { profile: 'load' }
}
</script>
<style scoped>
.red-text {
  font-weight: 900;
}
</style>
